/* eslint-disable no-underscore-dangle */
import { configureStore as createReduxStore } from '@reduxjs/toolkit';
import createReducer from './reducers';
import * as analytics from './analytics/analytics';
import config from './config';

/**
 * Create a new store with the given initial state. Adds Redux
 * middleware and enhancers.
 */
export default function configureStore(initialState = {}, sdk = null, analyticsHandlers = []) {
  const store = createReduxStore({
    reducer: createReducer(),
    preloadedState: initialState,
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware({
        thunk: {
          extraArgument: sdk,
        },
        serializableCheck: false,
        immutableCheck: false,
      }).concat(analytics.createMiddleware(analyticsHandlers)),
    devTools: config.dev,
  });

  return store;
}